import { render, staticRenderFns } from "./specificlearn.vue?vue&type=template&id=4998d960&"
import script from "./specificlearn.js?vue&type=script&lang=js&"
export * from "./specificlearn.js?vue&type=script&lang=js&"
import style0 from "./specificlearn.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports